import { Type } from 'class-transformer';
import { Model } from './model';
import type { TaskStatus } from './task';
import { User } from './user';

export class TaskAction extends Model {
  id: string;

  user_id: string | null;

  input_data: Record<string, any> | null;

  output_data: Record<string, any> | null;

  reason: string | null;

  status: TaskStatus | null;

  @Type(() => User)
  user: User | null;
}
